<script setup lang="ts">
import CursorPulseCircle from '@/components/lib/CursorPulseCircle.vue'

interface BaseDashboardBannerProps {
  buttonText?: string
  buttonLink?: string
}

const props = defineProps<BaseDashboardBannerProps>()
</script>

<template>
  <CursorPulseCircle :elementBlacklistIds="['dashboard_learnMoreBtn']">
    <template #default>
      <div
        class="cntb font-poppins"
        style="--clr-primary: var(--clr-primary-brand)"
      >
        <div
          class="cntb_inner f-column"
          style="padding: 1rem clamp(1px, 4rem, 12vw); overflow: hidden"
        >
          <slot name="background" />
          <div
            class="d-flex py-2 flex-wrap f-column"
            style="position: relative; z-index: 6; gap: 1.25rem"
          >
            <div
              class="f-column f-wrap font-poppins"
              style="gap: 0rem"
            >
              <slot name="content" />
            </div>

            <div
              v-if="props.buttonText && props.buttonLink"
              style="position: relative"
              class="f-column f-center mr-auto"
            >
              <a
                id="dashboard_learnMoreBtn"
                style="
                  --radius: 0.5rem;
                  color: var(--clr-black-0) !important;
                  font-weight: 600;
                  padding: 23px 22px !important;
                "
                class="gw_btn gw_btn_primary cntb_message_btn weight_500 clr-white text-h7 py-8 px-10"
                :href="props.buttonLink"
                target="_blank"
              >
                {{ props.buttonText }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </CursorPulseCircle>
</template>

<style lang="scss" scoped>
.svg-holder {
  z-index: 1;
  position: absolute;
  right: 2%;
  top: -124%;
  height: 33rem;
  svg {
    width: 100%;
    height: 100%;
  }
}
.cntb_tag {
  position: absolute;
  z-index: 1;
  top: 0.8rem;
  left: -3.2rem;
  font-size: 1rem;
  padding: 0.4rem 4rem;
  text-align: center;
  transform: rotate(-45deg);
  font-weight: 700;
}
.banner-link-text {
  color: var(--clr-white) !important;
  transition: all 0.3s ease;
}
.cntb {
  position: relative;
  background: #1d1d1d;
  width: 100%;
  flex-shrink: 0;
  border-radius: 8px;
}
.cntb_inner {
  border-radius: 8px;
  background: var(--clr-black-0);
  border: solid var(--clr-black-1) 1px;
  position: relative;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  z-index: 4;
}
.cntb_img {
  width: 25%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cntb_message {
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 1.75rem;
  font-weight: 700;
  width: 37.5%;
  padding: 0 2rem 0 1rem;
  line-height: 1.3;
}
.cntb_message_btn {
  min-width: 7.5rem;
}
@media (max-width: 1024px) {
  .cntb_inner_back {
    background-position-x: 50%;
  }
}
@media (max-width: 500px) {
  .svg-holder {
    right: 2%;
    top: -50%;
    height: 33rem;
  }
  .cntb_inner_back {
    background-position-x: 50%;
  }
}
</style>
